package com.exura.features.plandefinition.usecase

import com.exura.features.firebase.domain.model.versioning.Version
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionMetadata
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.ProviderVersionedTreatmentRepository

class UpdateTreatmentPlanUseCase(
    private val repository: ProviderVersionedTreatmentRepository
) {
    suspend operator fun invoke(plan: BasePlan, dest: String): Result<Version<BasePlan, PlanDefinitionMetadata>>
    = repository.update(plan, dest)
}
